function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#000"
        d="M7.024 8.012a7.917 7.917 0 002.964 2.964l.664-.929a.75.75 0 01.97-.222 8.566 8.566 0 003.437 1.023c.39.03.691.356.691.747v3.348a.75.75 0 01-.673.746c-.398.04-.799.061-1.202.061-6.42 0-11.625-5.205-11.625-11.625 0-.403.02-.804.061-1.202a.75.75 0 01.746-.673h3.348c.39 0 .716.3.747.69a8.566 8.566 0 001.023 3.438.75.75 0 01-.222.97l-.929.664zm-1.89-.493L6.557 6.5a10.057 10.057 0 01-.823-2.751H3.757c-.005.125-.007.25-.007.375 0 5.592 4.533 10.125 10.125 10.125.125 0 .25-.002.375-.007v-1.979a10.058 10.058 0 01-2.751-.822l-1.018 1.425a9.337 9.337 0 01-1.19-.562l-.044-.025A9.417 9.417 0 015.72 8.753l-.025-.044a9.332 9.332 0 01-.562-1.19z"
      ></path>
    </svg>
  );
}

export default Icon;
